import { defineMessages } from 'react-intl';

export const priceValueMessages = defineMessages({
  currentPrice: {
    id: 'price.aria.currentPrice.label',
    defaultMessage: 'Aktueller Preis',
  },
});
